<template>
  <div class="container">
    <h2>Alapadatok</h2>
    <div>
      <div class="form-group row mb-3">
        <div v-show="false" class="form-group row mb-3">
          <label class="col-sm-4"
            >Ki köti a biztosítást? <span class="text-danger" style="fontSize: 19px">*</span></label
          >
          <div class="col-sm-8">
            <div class="row">
              <input type="text" hidden name="is_agent" :value="0" v-if="isAgent == 0" />
              <input type="text" hidden name="is_agent" :value="1" v-else-if="isAgent == 2" />
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="isAgent = 0"
                  :class="{
                    'btn-red': isAgent == 0,
                    'btn-outline-danger': isAgent !== 0,
                  }"
                >
                  Ügyfél
                </div>
              </div>
              <div class="col-md-4 form-group mb-2">
                <div
                  class="btn w-100"
                  @click="isAgent = 1"
                  :class="{
                    'btn-red': isAgent == 1,
                    'btn-outline-danger': isAgent !== 1,
                  }"
                >
                  Értékesítő
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isAgent == 1" class="form-group row">
          <div class="input-group">
            <label class="col-sm-4" for="agent_id">Értékesítő azonosító: </label>
            <input
              class="form-control dark-border"
              id="agent_id"
              name="agent_id"
              v-model="agentId"
            />
          </div>
        </div>
        <div class="row ">
          <label class="col-sm-4"
            >Kérjük, adja meg a biztosított születési dátumát:
            <span class="text-danger" style="fontSize: 19px">*</span></label
          >
          <div class="col-md-8 mb-3 row align-self-end">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  style="backgroundColor: white"
                  id="ins_birthdate-prepend_firstpage"
                  ><label for="ins_birthdate_1">Születési dátum:</label>
                  <span class="text-danger" style="fontSize: 19px">*</span></span
                >
              </div>
              <input
                id="ins_birthdate_1"
                autocomplete="off"
                class="form-control dark-border"
                type="date"
                name="ins_birthdate"
                :min="birthMinDate"
                :max="birthMaxDate"
                v-model="insuredBornDate"
                required
              />
              <!-- <Datepicker
                id="ins_birthdate"
                name="ins_birthdate"
                :format="'yyyy-MM-dd'"
                :placeholder="'Kattintson ide a dátum kiválasztásához'"
                :language="hu"
                :disabled-dates="bornDisabledDates"
                :typeable="false"
                input-class="form-control"
                :open-date="bornInitialDate"
                required
                v-model="insuredBornDate"
                aria-describedby="ins_birthdate-prepend_2"
                class="datepicker-prepend-input"
              ></Datepicker> -->
            </div>
            <small>A biztosítás kizárólag 12 - 80 éves korú személyek számára köthető</small><br />
            <ValidationProvider :immediate="true" rules="required" v-slot="{errors}">
              <input type="text" name="insuredBornDate" :value="insuredBornDate" disabled hidden />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-4" for="sport"
            >Kérjük, válassza ki a sportágat:
            <span class="text-danger" style="fontSize: 19px">*</span></label
          >
          <div class="col-sm-8">
            <div class="row">
              <div class="col-md-4 mb-2">
                <ValidationProvider :immediate="true" rules="required" v-slot="{errors}">
                  <select
                    class="form-select dark-border"
                    id="sport"
                    name="sport"
                    v-model="chosenSport"
                    required
                  >
                    <option value="" selected disabled>Kérem, válasszon!</option>
                    <option v-for="(value, key) in sportok" :key="key" :value="key">{{
                      sportNames[key]
                    }}</option>
                  </select>
                  <small class="text-danger input-alert">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>
              <!-- <div class="col-md-4 mb-2">
                <input
                  type="text"
                  class="form-control mb-2"
                  readonly
                  name="sport_limit"
                  :value="sportok[chosenSport]"
                />
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="sportok[chosenSport] === 'draga' && chosenSport !== 'egyeb'">
        <span class="col-sm-4"
          >Kérjük, válassza ki a csomagot:
          <span class="text-danger" style="fontSize: 19px;">*</span></span
        >
        <ValidationProvider :immediate="true" rules="required" v-slot="{errors}">
          <input type="text" id="package" hidden v-model="chosenPackage" name="package" />
          <div class="d-flex flex-column flex-lg-row justify-content-between flex-wrap gap-4 mt-4">
            <div
              :class="{
                'card-selected': chosenPackage == 'alap',
                'card mx-auto': true,
              }"
              style="width: 18rem"
            >
              <div
                class="card-header draga"
                style="background-color: #007AA1; cursor: pointer"
                @click="chosenPackage = 'alap'"
                @keydown.enter="chosenPackage = 'alap'"
                @keydown.space.prevent="chosenPackage = 'alap'"
                tabindex="0"
                role="radio"
                aria-checked="false"
                aria-labelledby="alap-draga-label"
              >
                <h4 id="alap-draga-label">Alapcsomag</h4>
              </div>
              <div class="card-body">
                <div>
                  <table class="table" aria-label="alap-draga-table">
                    <thead>
                      <tr>
                        <th>Biztosítási fedezet</th>
                        <th>Biztosítási összeg</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Baleseti halál</td>
                        <td>{{ limitek.draga.alap.limit.halal | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Temetési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_temetes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.alap.limit.temetes | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti maradandó rokkantság (1-100%)</td>
                        <td>{{ limitek.draga.alap.limit.rokkantsag | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Átképzési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_atkepzes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.alap.limit.atkepzes | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Kerekesszék térítés
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_kerekesszek-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.alap.limit.kerekesszek | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi műtéti szolgáltatás baleset esetén (1-100%)</td>
                        <td>{{ limitek.draga.alap.limit.mutet | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi napi térítés baleset esetén (1-30 napig)</td>
                        <td>{{ limitek.draga.alap.limit.napiterites | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti eredetű csonttörés (egyösszegű)</td>
                        <td>{{ limitek.draga.alap.limit.csonttores | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Ideiglenes teljes keresőképtelenség baleset esetén (egyösszegű térítés,
                          legalább 46 nap keresőképtelenség esetén)
                        </td>
                        <td>{{ limitek.draga.alap.limit.keresokeptelenseg | currency }}</td>
                      </tr>
                      <tr>
                        <td>Éves biztosítási díj</td>
                        <td>{{ limitek.draga.alap.dij | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <button
                  type="button"
                  class="btn w-100 h-100 d-flex align-items-center justify-content-center"
                  @click="chosenPackage = 'alap'"
                  :class="{
                    'btn-red': chosenPackage == 'alap',
                    'btn-outline-danger': chosenPackage !== 'alap',
                  }"
                >
                  {{ chosenPackage == 'alap' ? 'Kiválasztva' : 'Ezt választom' }}
                </button>
              </div>
            </div>
            <div
              class="card mx-auto"
              :class="{
                'card-selected': chosenPackage == 'kozepes',
              }"
              style="width: 18rem;"
            >
              <div
                class="card-header draga"
                style="background-color: #007AA1; cursor: pointer"
                @click="chosenPackage = 'kozepes'"
                @keydown.enter="chosenPackage = 'kozepes'"
                @keydown.space.prevent="chosenPackage = 'kozepes'"
                tabindex="0"
                role="radio"
                aria-checked="false"
                aria-labelledby="kozepes-draga-label"
              >
                <h4 id="kozepes-draga-label">Közepes csomag</h4>
              </div>
              <div class="card-body">
                <div>
                  <table class="table" aria-label="kozepes-draga-table">
                    <thead>
                      <tr>
                        <th>Biztosítási fedezet</th>
                        <th>Biztosítási összeg</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Baleseti halál</td>
                        <td>{{ limitek.draga.kozepes.limit.halal | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Temetési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_temetes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.kozepes.limit.temetes | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti maradandó rokkantság (1-100%)</td>
                        <td>{{ limitek.draga.kozepes.limit.rokkantsag | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Átképzési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_atkepzes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.kozepes.limit.atkepzes | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Kerekesszék térítés
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_kerekesszek-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.kozepes.limit.kerekesszek | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi műtéti szolgáltatás baleset esetén (1-100%)</td>
                        <td>{{ limitek.draga.kozepes.limit.mutet | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi napi térítés baleset esetén (1-30 napig)</td>
                        <td>{{ limitek.draga.kozepes.limit.napiterites | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti eredetű csonttörés (egyösszegű)</td>
                        <td>{{ limitek.draga.kozepes.limit.csonttores | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Ideiglenes teljes keresőképtelenség baleset esetén (egyösszegű térítés,
                          legalább 46 nap keresőképtelenség esetén)
                        </td>
                        <td>{{ limitek.draga.kozepes.limit.keresokeptelenseg | currency }}</td>
                      </tr>
                      <tr>
                        <td>Éves biztosítási díj</td>
                        <td>{{ limitek.draga.kozepes.dij | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <button
                  type="button"
                  class="btn w-100 h-100 d-flex align-items-center justify-content-center"
                  @click="chosenPackage = 'kozepes'"
                  :class="{
                    'btn-red': chosenPackage == 'kozepes',
                    'btn-outline-danger': chosenPackage !== 'kozepes',
                  }"
                >
                  {{ chosenPackage == 'kozepes' ? 'Kiválasztva' : 'Ezt választom' }}
                </button>
              </div>
            </div>
            <div
              class="card mx-auto"
              :class="{
                'card-selected': chosenPackage == 'kiemelt',
              }"
              style="width: 18rem;"
            >
              <div
                class="card-header draga"
                style="background-color: #007AA1; cursor: pointer"
                @click="chosenPackage = 'kiemelt'"
                @keydown.enter="chosenPackage = 'kiemelt'"
                @keydown.space.prevent="chosenPackage = 'kiemelt'"
                tabindex="0"
                role="radio"
                aria-checked="false"
                aria-labelledby="kiemelt-draga-label"
              >
                <h4 id="kiemelt-draga-label">Kiemelt csomag</h4>
              </div>
              <div class="card-body">
                <div>
                  <table class="table" aria-label="kiemelt-draga-table">
                    <thead>
                      <tr>
                        <th>Biztosítási fedezet</th>
                        <th>Biztosítási összeg</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Baleseti halál</td>
                        <td>{{ limitek.draga.kiemelt.limit.halal | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Temetési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_temetes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.kiemelt.limit.temetes | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti maradandó rokkantság (1-100%)</td>
                        <td>{{ limitek.draga.kiemelt.limit.rokkantsag | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Átképzési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_atkepzes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.kiemelt.limit.atkepzes | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Kerekesszék térítés
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_kerekesszek-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.draga.kiemelt.limit.kerekesszek | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi műtéti szolgáltatás baleset esetén (1-100%)</td>
                        <td>{{ limitek.draga.kiemelt.limit.mutet | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi napi térítés baleset esetén (1-30 napig)</td>
                        <td>{{ limitek.draga.kiemelt.limit.napiterites | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti eredetű csonttörés (egyösszegű)</td>
                        <td>{{ limitek.draga.kiemelt.limit.csonttores | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Ideiglenes teljes keresőképtelenség baleset esetén (egyösszegű térítés,
                          legalább 46 nap keresőképtelenség esetén)
                        </td>
                        <td>{{ limitek.draga.kiemelt.limit.keresokeptelenseg | currency }}</td>
                      </tr>
                      <tr>
                        <td>Éves biztosítási díj</td>
                        <td>{{ limitek.draga.kiemelt.dij | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <button
                  type="button"
                  class="btn w-100 h-100 d-flex align-items-center justify-content-center"
                  @click="chosenPackage = 'kiemelt'"
                  :class="{
                    'btn-red': chosenPackage == 'kiemelt',
                    'btn-outline-danger': chosenPackage !== 'kiemelt',
                  }"
                >
                  {{ chosenPackage == 'kiemelt' ? 'Kiválasztva' : 'Ezt választom' }}
                </button>
              </div>
            </div>
          </div>
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div v-if="sportok[chosenSport] === 'olcso' && chosenSport !== 'egyeb'">
        <ValidationProvider :immediate="true" rules="required" v-slot="{errors}">
          <span class="col-sm-4"
            >Kérjük, válassza ki a csomagot:
            <span class="text-danger" style="fontSize: 19px">*</span></span
          >
          <input type="text" id="package" hidden v-model="chosenPackage" name="package" />
          <div class="d-flex flex-column flex-lg-row justify-content-between flex-wrap gap-4 mt-4">
            <div
              class="card mx-auto"
              :class="{
                'card-selected': chosenPackage == 'alap',
              }"
              style="width: 18rem"
            >
              <div
                class="card-header olcso"
                style="background-color: #007AA1; cursor: pointer;"
                @click="chosenPackage = 'alap'"
                @keydown.enter="chosenPackage = 'alap'"
                @keydown.space.prevent="chosenPackage = 'alap'"
                tabindex="0"
                role="radio"
                aria-checked="false"
                aria-labelledby="alap-olcso-label"
              >
                <h4 id="alap-olcso-label">Alapcsomag</h4>
              </div>
              <div class="card-body">
                <div>
                  <table class="table" aria-label="alap-olcso-table">
                    <thead>
                      <tr>
                        <th>Biztosítási fedezet</th>
                        <th>Biztosítási összeg</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Baleseti halál</td>
                        <td>{{ limitek.olcso.alap.limit.halal | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Temetési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_temetes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.olcso.alap.limit.temetes | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti maradandó rokkantság (1-100%)</td>
                        <td>{{ limitek.olcso.alap.limit.rokkantsag | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Átképzési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_atkepzes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.olcso.alap.limit.atkepzes | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Kerekesszék térítés
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_kerekesszek-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.olcso.alap.limit.kerekesszek | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi műtéti szolgáltatás baleset esetén (1-100%)</td>
                        <td>{{ limitek.olcso.alap.limit.mutet | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi napi térítés baleset esetén (1-30 napig)</td>
                        <td>{{ limitek.olcso.alap.limit.napiterites | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti eredetű csonttörés (egyösszegű)</td>
                        <td>{{ limitek.olcso.alap.limit.csonttores | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Ideiglenes teljes keresőképtelenség baleset esetén (egyösszegű térítés,
                          legalább 46 nap keresőképtelenség esetén)
                        </td>
                        <td>{{ limitek.olcso.alap.limit.keresokeptelenseg | currency }}</td>
                      </tr>
                      <tr>
                        <td>Éves biztosítási díj</td>
                        <td>{{ limitek.olcso.alap.dij | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <button
                  type="button"
                  class="btn w-100 h-100 d-flex align-items-center justify-content-center"
                  @click="chosenPackage = 'alap'"
                  :class="{
                    'btn-red': chosenPackage == 'alap',
                    'btn-outline-danger': chosenPackage !== 'alap',
                  }"
                >
                  {{ chosenPackage == 'alap' ? 'Kiválasztva' : 'Ezt választom' }}
                </button>
              </div>
            </div>
            <!-- <div
              class="card mx-auto"
              :class="{
                'card-selected': chosenPackage == 'kozepes',
              }"
              style="width: 18rem;"
            >
              <div class="card-header nincs" style="background-color: #616060">
                <h4>Közepes csomag</h4>
              </div>
              <div class="card-body nincs">
                <div class="table-responsive nincs">
                  <table class="table">
                    <thead>
                      <tr>
                        <th class="olcso">Ilyen csomagot nem értékesítünk</th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div> -->
            <div
              class="card mx-auto"
              :class="{
                'card-selected': chosenPackage == 'kiemelt',
              }"
              style="width: 18rem"
            >
              <div
                class="card-header olcso"
                style="background-color: #007AA1; cursor: pointer;"
                @click="chosenPackage = 'kiemelt'"
                @keydown.enter="chosenPackage = 'kiemelt'"
                @keydown.space.prevent="chosenPackage = 'kiemelt'"
                tabindex="0"
                role="radio"
                aria-checked="false"
                aria-labelledby="kiemelt-olcso-label"
              >
                <h4 id="kiemelt-olcso-label">Kiemelt csomag</h4>
              </div>
              <div class="card-body">
                <div>
                  <table class="table" aria-label="kiemelt-olcso-table">
                    <thead>
                      <tr>
                        <th>Biztosítási fedezet</th>
                        <th>Biztosítási összeg</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Baleseti halál</td>
                        <td>{{ limitek.olcso.kiemelt.limit.halal | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Temetési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_temetes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.olcso.kiemelt.limit.temetes | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti maradandó rokkantság (1-100%)</td>
                        <td>{{ limitek.olcso.kiemelt.limit.rokkantsag | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Átképzési költség
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_atkepzes-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.olcso.kiemelt.limit.atkepzes | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Kerekesszék térítés
                          <button
                            type="button"
                            class="info border border-white"
                            name="fed_kerekesszek-tooltip"
                            data-toggle="tooltip"
                            data-placement="right"
                            title=""
                          >
                            ?
                          </button>
                        </td>
                        <td>{{ limitek.olcso.kiemelt.limit.kerekesszek | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi műtéti szolgáltatás baleset esetén (1-100%)</td>
                        <td>{{ limitek.olcso.kiemelt.limit.mutet | currency }}</td>
                      </tr>
                      <tr>
                        <td>Kórházi napi térítés baleset esetén (1-30 napig)</td>
                        <td>{{ limitek.olcso.kiemelt.limit.napiterites | currency }}</td>
                      </tr>
                      <tr>
                        <td>Baleseti eredetű csonttörés (egyösszegű)</td>
                        <td>{{ limitek.olcso.kiemelt.limit.csonttores | currency }}</td>
                      </tr>
                      <tr>
                        <td>
                          Ideiglenes teljes keresőképtelenség baleset esetén (egyösszegű térítés,
                          legalább 46 nap keresőképtelenség esetén)
                        </td>
                        <td>{{ limitek.olcso.kiemelt.limit.keresokeptelenseg | currency }}</td>
                      </tr>
                      <tr>
                        <td>Éves biztosítási díj</td>
                        <td>{{ limitek.olcso.kiemelt.dij | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <button
                  type="button"
                  class="btn w-100 h-100 d-flex align-items-center justify-content-center"
                  @click="chosenPackage = 'kiemelt'"
                  :class="{
                    'btn-red': chosenPackage == 'kiemelt',
                    'btn-outline-danger': chosenPackage !== 'kiemelt',
                  }"
                >
                  {{ chosenPackage == 'kiemelt' ? 'Kiválasztva' : 'Ezt választom' }}
                </button>
              </div>
            </div>
          </div>
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
      <div v-if="chosenSport === 'egyeb'">
        <h4 class="col-sm-12">
          „Egyéb sport" választása miatt egyedi kockázatelbírás szükséges. Kérjük, küldjön
          megkeresést részünkre az <b>info@colonnade.hu</b> e-mail címre, a tárgyban tüntesse fel:
          „Sportintézet Csoportos Colonnade Sportbaleset-biztosítás”.
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import SideBuilding from './components/SideBuilding';
import Select2 from 'v-select2-component';
import Datepicker from 'vuejs-datepicker';
import {hu} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

export default {
  components: {
    SideBuilding,
    Select2,
    Datepicker,
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1);
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - 80);
    minDate.setMonth(1);
    minDate.setDate(1);
    const maxDateIns = new Date();
    maxDateIns.setFullYear(today.getFullYear() - 12);
    maxDateIns.setMonth(now.getMonth());
    maxDateIns.setDate(now.getDate());
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18);
    maxDate.setMonth(now.getMonth());
    maxDate.setDate(now.getDate());
    const birthMinDate = moment(minDate).format('YYYY-MM-DD');
    const birthMaxDate = moment(maxDateIns).format('YYYY-MM-DD');
    return {
      hu: hu,
      cityNames: [],
      summaryPrice: 0,
      clickedMainBuildingPrice: false,
      clickedSideBuildingPrice: false,
      clickedAllGoodsPrice: false,
      bornInitialDate: maxDateIns,
      bornDisabledDates: {
        customPredictor: function(date) {
          return date > maxDateIns || date < minDate;
        },
      },
      birthMinDate,
      birthMaxDate,
    };
  },
  computed: {
    ...mapFields([
      'cities',
      'generalInfo.chosenSport',
      'generalInfo.chosenPackage',
      'generalInfo.contractType',
      'generalInfo.isAgent',
      'generalInfo.agentId',
      'generalInfo.propertyType',
      'generalInfo.propertyInhabitated',
      'generalInfo.propertyOutskirts',
      'generalInfo.propertyPhysicalJob',
      'generalInfo.propertyPhysicalJobName',
      'generalInfo.propertyOwnRight',
      'generalInfo.propertyZip',
      'generalInfo.propertyName',
      'generalInfo.selectedPropertyName',

      // Main Building Insurance
      'insuranceProperty.floorArea',
      'insuranceProperty.recommendedInsurancePrice',
      'insuranceProperty.chosenInsurancePrice',
      'insuranceProperty.builtYear',
      'insuranceProperty.residents',
      'insuranceProperty.wallType',
      'insuranceProperty.roofType',
      // Personal Goods
      'insurancePersonalGoods.calculatedInsurancePrice',
      'insurancePersonalGoods.acceptCalculatedInsurance',
      'insurancePersonalGoods.allGoodsPrice',
      'MFOLoaded',
      'dm',
      'partnertipus',
      'sportok',
      'limitek',
      'sportNames',
      'insuredSettings.contractedIsInsured',
    ]),
    ...mapFields({
      sideBuildingsTemplate: 'insuranceSideBuildings.template',
      sideBuildings: 'insuranceSideBuildings.list',
      insuredBornDate: 'insuredSettings.bornDate',
      sideBuildingsRecommendedPrice: 'insuranceSideBuildings.recommendedInsurancePrice',
      sideBuildingsChosenPrice: 'insuranceSideBuildings.chosenInsurancePrice',
      paymentType: 'paymentOptions.type',
      paymentFrequency: 'paymentOptions.frequency',
    }),
    ...mapGetters({
      data: 'getAllState',
    }),
    propertyNameIsArray: function() {
      return (
        typeof this.propertyName === 'object' && this.propertyName && this.propertyName.length > 0
      );
    },
    zipCodes: {
      get() {
        return Object.keys(this.cities);
      },
    },
  },
  watch: {
    paymentFrequency: function(value) {
      if (value == 'havi' && !this.canChooseMonthlyPayment) this.paymentFrequency = 'negyedeves';
    },
    propertyType: function(type) {
      if (!this.MFOLoaded) return;

      if (type == 'lakas') {
        this.wallType = 'panel';
        this.roofType = 'bitumen';
      } else {
        this.wallType = 'tegla';
        this.roofType = 'cserep';
      }
    },
    chosenSport: function(value) {
      this.$store.dispatch('getMarks');
    },
    propertyZip: function() {
      const zipCodeList = Object.keys(this.cities);
      if (
        zipCodeList.length === 0 ||
        (zipCodeList.length > 0 && !zipCodeList.includes(this.propertyZip))
      )
        return (this.cityNames = []);

      const zipData = this.cities[this.propertyZip];

      if (!zipData) return (this.cityNames = []);

      this.cityNames =
        typeof zipData.telepules === 'string'
          ? [zipData.telepules]
          : Object.values(zipData.telepules);

      if (this.cityNames.length === 1) {
        this.selectedPropertyName = this.cityNames[0];
      }
    },
    isAgent: function() {
      if (this.isAgent === 0)
        this.$store.commit('setGeneralPropertyValues', {
          name: 'agentId',
          value: '',
        });
    },
    // chosenSport: function() {
    //   if (this.chosenSport === 'egyeb') {
    //     this.chosenPackage = 'alap';
    //   }
    // },
    chosenInsurancePrice: function(value) {
      if (!this.clickedMainBuildingPrice) return;

      this.$store.commit('setMainInsuranceChangedState', true);
    },
    sideBuildingsChosenPrice: function(value) {
      if (!this.clickedSideBuildingPrice) return;

      this.$store.commit('setSideInsuranceChangedState', true);
    },
    allGoodsPrice: function(value) {
      if (!this.clickedAllGoodsPrice) return;

      this.$store.commit('setAllGoodsPriceChangedState', true);
    },
    propertyPhysicalJob: function(job) {
      if (job === 0) {
        this.$store.commit('setGeneralPropertyValues', {
          name: 'propertyPhysicalJobName',
          value: '',
        });
      }
    },
    insuredBornDate: function(date) {
      if (this.getAge(date) < 18) this.contractedIsInsured = 0;
    },
  },
  mounted() {
    if (this.paymentFrequency == 'havi' && !this.canChooseMonthlyPayment)
      this.paymentFrequency = 'negyedeves';
  },
  created() {
    this.$store.dispatch('updateMarks');
  },
  methods: {
    showPropertyWallWarning() {
      return ['valyog', 'vegyes'].includes(this.wallType);
    },
    showPropertyRoofWarning() {
      return ['nad', 'fazsindely', 'szalma', 'muanyag', 'hullamlemez'].includes(this.roofType);
    },
    addSideBuilding() {
      if (this.sideBuildings.length < 5)
        this.$store.commit('addSideBuilding', Object.assign({}, this.sideBuildingsTemplate));
    },
    showPropertyPhysicalWarning() {
      return this.propertyPhysicalJob === 1;
    },
    getAge(birthDate) {
      var today = new Date();
      const birthDateAsDate = new Date(birthDate);
      var age = today.getFullYear() - birthDateAsDate.getFullYear();
      var m = today.getMonth() - birthDateAsDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDateAsDate.getDate())) {
        age--;
      }
      return age;
    },
  },
};
</script>

<style lang="scss">
.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #66889b;
}
.select2-selection__arrow {
  height: 38px !important;
}

.nincs {
  background-color: #616060;
  color: white;
}

.card-selected {
  background-color: #ece17a !important;
  border: #ece17a !important;
  border-radius: 5px !important;
  box-shadow: 0 0 50px 8px #007aa1;
  &:focus {
    outline-color: #000000;
    box-shadow: 0 0 50px 8px #007aa1;
  }
  &:focus:hover {
    outline-color: #000000;
    box-shadow: 0 0 50px 8px #007aa1;
  }
}

.card-header {
  color: white;
  &:focus,
  &:hover,
  &:focus-visible {
    /* inner indicator */
    outline: 2px #fff solid !important;
    outline-offset: 0 !important;
    /* outer indicator */
    box-shadow: 0 0 0 4px #000 !important;
  }
}
</style>
